import { authState } from "@/constants/plugins/auth";

const getBody = <T>(c: Response | Request): Promise<T> => {
	const contentType = c.headers.get("content-type");

	if (contentType?.includes("application/json")) {
		return c.json();
	}

	if (contentType?.includes("application/pdf")) {
		return c.blob() as Promise<T>;
	}

	return c.text() as Promise<T>;
};

const getHeaders = (initialHeaders?: HeadersInit): HeadersInit => {
	const headers = new Headers({ ...initialHeaders });

	if (authState.isAuthenticated) {
		// When impersonation is back, use impersonation token
		headers.append("Authorization", `Bearer ${authState.accessToken}`);
	}

	return headers;
};

export const customFetch = async <T>(url: string, options: RequestInit): Promise<T> => {
	const requestUrl = url;
	const requestHeaders = getHeaders(options.headers);

	const requestInit: RequestInit = {
		...options,
		headers: requestHeaders,
	};

	const response = await fetch(requestUrl, requestInit);
	const data = await getBody<T>(response);

	return { status: response.status, data, headers: response.headers } as T;
};
